import { CardSignalType, CardWeight } from "./types";

export const LOADING_DURATION_MS = 1800;

export const WEIGHT_CONFIG: Record<
  CardWeight,
  { label: string; bg: string; fg: string }
> = {
  KEY_FOCUS: { label: "Key focus", bg: "bg-red-100", fg: "text-red-700" },
  WORTH_DISCUSSING: {
    label: "Worth discussing",
    bg: "bg-amber-100",
    fg: "text-amber-700",
  },
  IF_TIME_ALLOWS: {
    label: "If time allows",
    bg: "bg-green-100",
    fg: "text-green-700",
  },
};

export const SIGNAL_TYPE_LABELS: Record<CardSignalType, string> = {
  NEEDS_CLARITY: "Needs clarity",
  MISSING_EVIDENCE: "Missing evidence",
  ACTION_NEEDED: "Action needed",
  OPPORTUNITY: "Opportunity",
  CHECK_IN: "Check in",
};
